export const authClientId = "hsOzJQmGkLHnpCHIX65T1K8HQzoi8Ag6";
export const authDomain = "dev-8-q69az8.eu.auth0.com";
export const callbackUrl = "https://localhost:3000/callback"; // modify `callbackUrl` to point to your localhost
export const audienceUrl = "https://dev-8-q69az8.eu.auth0.com/api/v2/";
export const hasuraUrl = "https://suited-pup-54.hasura.app/v1/graphql";
export const defaultPicture = "/defaultImg.jpg";